import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";

export const Route = createFileRoute("/dual-use-accelerator/")({
  head: () => ({
    meta: [
      { title: "Dual Use Accelerator | Maven Scouts" },
      { name: "description", content: "Explore the MavenWERX 15-week dual-use accelerator for founders entering commercial and defense markets." },
      { property: "og:title", content: "Dual Use Accelerator | Maven Scouts" },
      { property: "og:description", content: "Explore the MavenWERX 15-week dual-use accelerator for founders entering commercial and defense markets." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: Index,
});
